import type { TurtlePersona } from "./specs";

export const TURTLE_PERSONAS: Record<string, TurtlePersona> = {
  prop_turtle_a: {
    name: "Fred",
    level: 68,
    spec: "Max Specs",
    flair: "the Sandtreader",
  },
  prop_turtle_b: {
    name: "Shellbert",
    level: 42,
    spec: "Tide Whisperer",
    flair: "absolute unit",
  },
  prop_turtle_c: {
    name: "Crunkles",
    level: 7,
    spec: "Reef Sage",
    flair: "smol but fierce",
  },
  prop_turtle_d: {
    name: "Trevor",
    level: 99,
    spec: "Lagoon Lord",
    flair: "do not approach",
  },
  prop_turtle_e: {
    name: "Big Mama",
    level: 88,
    spec: "Egg Layer",
    flair: "queen of the beach",
  },
  prop_turtle_f: {
    name: "Squirt",
    level: 3,
    spec: "Hatchling",
    flair: "freshly hatched",
  },
  prop_turtle_g: {
    name: "Yoshi",
    level: 25,
    spec: "Speedrunner",
    flair: "wrong franchise",
  },
  prop_turtle_h: {
    name: "Donatello",
    level: 50,
    spec: "Pizza Connoisseur",
    flair: "cowabunga",
  },
};
